import { render, staticRenderFns } from "./ReleaseModal.vue?vue&type=template&id=03649a5a&scoped=true&"
import script from "./ReleaseModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseModal.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseModal.vue?vue&type=style&index=0&id=03649a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03649a5a",
  null
  
)

export default component.exports